<template>
  <div class="tenant">
    <div class="tenant-header">
      <img alt="" class="img "  src="@/assets/img/tenant/logo@2x.png">
      <span class="header-text"></span>
    </div>
    <div class="main">
      <div class="tenant-wel">
      <div class="wel">  Welcome ！</div>
      <div class="introduce">{{ $t('user.tenantLogin') }}</div>
      <div class="introduce">{{ $t('user.tenantTo') }}</div>
    </div>
    <div class="login-select">
      <div class="tile">{{$t('user.tenantSelect')}}</div>
      <div class="content">
        <ul>
          <li v-for="item in dataList" :key="item.tenantId" >
            <div class="content-pic"  @click="toLoginPage(item)">
          <img alt="" class="img-login "  src="@/assets/img/tenant/boxlogin.png">
          <div class="card-content">
            <div class="content-pic" >
                      <img alt="" class="img "  src="@/assets/img/tenant/logo.png">
                    </div>
                    <div class="content-text">{{item.tenantName}}</div>
                    <div class="content-click">
                      <img alt="" class="img "  src="@/assets/img/tenant/icon.png">
                    </div>
          </div>
            </div>
           </li>
        </ul>
      </div>
    </div>
    </div>

    <div class="tenant-bac">

      <img alt="" class="img "  src="@/assets/img/tenant/background.png">
    </div>
    <!-- <el-card style="width: 320px; min-height: 400px;">
        <div slot="header">
            <el-row style="margin-bottom: 20px">
              <el-col>
                <span class="tenant-title">账号选择</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span>检测到您已关联多个企业，请选择进入账号</span>
              </el-col>
            </el-row>
        </div>
        <div style="width: 220px; margin: 0 auto;">
          <ul>
            <li v-for="item in dataList" :key="item.tenantId">
              <div class="_block-but" @click="toLoginPage(item)">
                <img src="https://testjoylearning.bmw.com.cn/test/img/BMW_Grey-Colour_RGB3.f8495867.png" width="50px" height="50px">
                <span style="float: right; margin-right: 30px; font-size: 16px" >{{ item.tenantName }}</span>
              </div>
            </li>
          </ul>
        </div>
    </el-card > -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: []
    }
  },
  created() {
    this.removeStorage(this.GLOBAL.TENANT_ID)
    this.removeStorage(this.GLOBAL.ACCESS_WHITELIST_DS)
    this.loadTenantList()
  },
  methods: {
    loadTenantList() {
       let tenantList=this.getStorage(this.GLOBAL.USER_NAME)
        this.$request.get("/sys/commTenant/selectList").then( res => {
        let tenantList1=res
        const result = tenantList1.filter(itemA => tenantList.some(itemB => itemB.tenantId === itemA.tenantId));
        this.dataList = result       
      })
    },
    toLoginPage(obj) {
      this.setStorage(this.GLOBAL.TENANT_ID, obj.tenantId)
      this.setStorage(this.GLOBAL.ACCESS_WHITELIST_DS, obj.tenantCategory)
      this.$router.push({name: 'protalMain', params: {action: 'autoLogin'}})
    }
  }
}
</script>

<style lang="scss" scoped>
.tenant{
  width: 1200px;
  height: 518px;
  background:#FFFFFF;
  .tenant-header{
    margin: 24px 0 0 53px;
    .img{
      width: 80px;
    }
    .header-text{
        width: 51px;
    height: 22px;
    font-size: 16px;
    font-family: BMWTypeNextLatinTT-Bold, BMWTypeNextLatinTT;
    font-weight: bold;
    color: #252628;
    line-height: 21px;
    letter-spacing: 1px;
  }
  }
  .main{
    display: flex;
    column-gap: 140px;

    .tenant-wel{
    .wel{
      position: sticky;
     white-space: nowrap;
     width: 450px;
    height: 96px;
    font-size: 51px;
    font-family: BMWTypeNextLatinTT-Bold, BMWTypeNextLatinTT;
    font-weight: bold;
    color: #252628;
    line-height: 90px;
    margin: -16px 0 0 158px;
    }
    .introduce{
    position: sticky;
    width: 606px;
    height: 24px;
    font-size: 16px;
    font-family: BMWTypeNextLatinTT-Regular, BMWTypeNextLatinTT;
    font-weight: 400;
    color: #666666;
    margin: -9px 0 0 170px;
    }

  }
  .login-select{
    margin: 0 0 0 -74px;
    .img-login{
        width: 100%;
        height:57px;
    }
    .tile{
      top:126px;
      position: absolute;
      width: 140px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #252628;
      line-height: 28px;
    }
    .content{
      top: 168px;
      position: absolute;
      cursor: pointer;
    .content-pic{
      height: 50px;
      
    }
 
   
    
      .card-content{
        width: 100%;
        display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          column-gap: 95px;
          margin-top: -28px;
          position: relative;
          top: -25px;
          align-items: center;
          text-align: center;
          margin-left: 9px;
       .content-pic{
       
        .img{
          width: 40px;
          margin-top: 14px;
          margin-left: 4px;
        }
       }
       .content-text{
        text-align:left;
        width: 45%;
        height: 33px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #252628;
        line-height: 33px;
        letter-spacing: 2px;
        white-space: nowrap;
        margin-left: -85px;
      }
      .content-click{
      width: 20%;
    display: flex;
    justify-content: flex-end;
    padding-right: 25px;
      }
      }

    }
  }
  }

  .tenant-bac{
    margin-top: -264px;
    .img{
    
      width: 771px;
         margin: 108px 0 0 107px;
    }
  }

}
// .img-login{
//   width: 100%;

// }
.tenant-title {
    font-size: 20px;
    font-weight: 700;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
ul li {
    margin-bottom: 15px
}
._block-but {
  line-height: 55px;
  text-align: left;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  cursor: pointer;
}
._block-but:hover {
  background: none;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#dcdcdc));
  background: -moz-linear-gradient(top, #fff, #dcdcdc);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#dcdcdc');
}
._block-but:active {
  color: rgb(121, 117, 117);
  background: -webkit-gradient(linear, left top, left bottom, from(#ededed), to(#fff));
  background: -moz-linear-gradient(top, #ededed, #fff);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ededed', endColorstr='#ffffff');
}
</style>
